import React from "react";
import { Link } from "react-router-dom";

export const AddElementsButton = ({ text, onClick, icon, className }) => {
  return (
    <button
      className={className}
      onClick={onClick}
      style={{ background: "#284945" }}
    >
      {icon && <i className={icon} style={{ marginRight: "5px" }}></i>}
      {text}
    </button>
  );
};

export const AddLinkButton = ({ text, icon, link }) => {
  return (
    <div>
      <Link to={link}>
        <button
          className="button-68"
          style={{ backgroundColor: "#284945", color: "white" }}
        >
          {icon && <i className={icon} style={{ marginRight: "5px" }}></i>}
          {text}
        </button>
      </Link>
    </div>
  );
};

export const AddActionsButton = ({ text, onClick, icon, className }) => {
  return (
    <button
      className={className}
      onClick={onClick}
      style={{ background: "#284945" }}
    >
      {icon && <span style={{ marginRight: "5px" }}>{icon}</span>}
      {text}
    </button>
  );
};

export const LinkAndClickButton = ({ text, icon, link, onClick }) => {
  return (
    <div>
      <Link to={link}>
        <button
          className="button-15"
          style={{ background: "#284945", color: "white" }}
          onClick={onClick}
        >
          {icon && <span style={{ marginRight: "5px" }}>{icon}</span>}
          {text}
        </button>
      </Link>
    </div>
  );
};

// export const AddAnElementButton = ({
//   text,
//   onClick,
//   icon,
//   className,
//   type = "button",
//   backgroundColor = "#284945",
//   disabled = false,
//   style = {},
//   ...rest
// }) => {
//   return (
//     <button
//       type={type}
//       className={className}
//       onClick={onClick}
//       disabled={disabled}
//       style={{
//         background: backgroundColor,
//         ...style,
//       }}
//       {...rest}
//     >
//       {icon && <i className={icon} style={{ marginRight: "5px" }}></i>}
//       {text}
//     </button>
//   );
// };

export const AddAnElementButton = ({
  text,
  onClick,
  icon,
  className,
  type = "button",
  backgroundColor = "#284945",
  disabled = false,
  style = {},
  ...rest
}) => {
  return (
    <button
      type={type}
      className={className}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={{
        background: backgroundColor,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.7 : 1,
        display: "flex",
        alignItems: "center",
        gap: "6px",
        ...style,
      }}
      {...rest}
    >
      {icon && icon}
      {text}
    </button>
  );
};

export const CloseFormButton = ({
  text,
  onClick,
  className,
  type = "button",
  disabled = false,
  backgroundColor = "#fff",
  color = "#c0392b",
  borderColor = "#c0392b",
  style = {},
  ...rest
}) => {
  return (
    <button
      type={type}
      className={className}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={{
        background: backgroundColor,
        color: color,
        border: `1px solid ${borderColor}`,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.7 : 1,
        ...style,
      }}
      {...rest}
    >
      {text}
    </button>
  );
};
